import { Component } from '@angular/core';
import { HomeBannerComponent } from '../home-banner/home-banner.component';
import { CategoryCardsComponent } from '../category-cards/category-cards.component';
import { SparePartsFilterComponent } from '../spare-parts-filter/spare-parts-filter.component';
import { RecentlyViewedPartsComponent } from '../recently-viewed-parts/recently-viewed-parts.component';
import { OrderSummaryStatsComponent } from '../order-summary-stats/order-summary-stats.component';
import { PartsforyouComponent } from '../partsforyou/partsforyou.component';
import { WhyChooseUsComponentComponent } from '../why-choose-us-component/why-choose-us-component.component';
import { MostSearchedModelsComponentComponent } from '../most-searched-models-component/most-searched-models-component.component';
import { CustomerFeedbackComponent } from '../customer-feedback/customer-feedback.component';
import { BlogsStoriesComponent } from '../blogs-stories/blogs-stories.component';
import { FaqComponent } from '../faq/faq.component';
import { StorageService } from '../../shared/services/storage.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    HomeBannerComponent,
    CategoryCardsComponent,
    SparePartsFilterComponent,
    RecentlyViewedPartsComponent,
    OrderSummaryStatsComponent,
    PartsforyouComponent,
    WhyChooseUsComponentComponent,
    MostSearchedModelsComponentComponent,
    CustomerFeedbackComponent,
    BlogsStoriesComponent,
    FaqComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  isLogging: boolean = false;

  constructor(private storageService: StorageService) {
    this.isLogging = !!this.storageService.getItem('user_code');
  }
}
